import { cn } from '../lib/utils';

/** Brand spinner with an accessible label. */
export const Spinner = ({ className, label = 'Loading' }) => (
  <div role="status" className={cn('flex items-center justify-center', className)}>
    <div className="animate-spin rounded-full h-12 w-12 border-2 border-gold/20 border-t-gold" />
    <span className="sr-only">{label}</span>
  </div>
);

/** Full-screen loading state used while a page's data is loading. */
export const PageLoader = ({ label = 'Loading' }) => (
  <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-paper">
    <Spinner label={label} />
    <p className="text-sm text-ink/50">{label}…</p>
  </div>
);

export default Spinner;
